import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import './Search.css';
import ProgressBar from './ProgressBar';
import { DateRange } from 'react-date-range';
import TopImage from '../../assets/Home/DSC_6678.JPG';
import RoomImage1 from '../../assets/Home/DSC_6678.JPG';
import format from 'date-fns/format';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { addDays } from 'date-fns';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import * as Icons from 'react-icons/fa'; // Import all icons from react-icons/fa


const initialRooms = [
    {
        id: 1,
        name: 'Apartment Triple Room – Full Board',
        price: 134.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 80 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 80 sq. ft.' },
            { icon: 'FaShower', text: 'Hot Water.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
    {
        id: 2,
        name: 'Apartment Triple Room – Half Board',
        price: 114.50,
        maxGuests: 3,
        image: RoomImage1,
        services: [
            { icon: 'FaBed', text: 'Bathroom 75 sq. ft.' },
            { icon: 'FaUtensils', text: 'Kitchen 70 sq. ft.' },
            { icon: 'FaShower', text: 'Bedroom 250 sq. ft.' },
            { icon: 'FaWifi', text: 'High Speed Internet' },
            { icon: 'FaColumns', text: 'Refrigerator' },
            { icon: 'FaAccusoft', text: 'Iron' },
            { icon: 'FaBed', text: 'Bed Room 300 square feet space' },
        ]
    },
];

function Search() {
    const [dateRange, setDateRange] = useState([{ startDate: new Date(), endDate: addDays(new Date(), 7), key: 'selection' }]);
    const [sortOrder, setSortOrder] = useState('default');
    const [priceRange, setPriceRange] = useState([33.5, 134.5]);
    const [currentPage, setCurrentPage] = useState(1);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [guests, setGuests] = useState(1);
    const [displayedRooms, setDisplayedRooms] = useState(initialRooms);

    const roomsPerPage = 10;

    const filterRooms = useCallback(() => {
        const numberOfDays = Math.ceil((dateRange[0].endDate - dateRange[0].startDate) / (1000 * 60 * 60 * 24)) + 1;

        // Calculate total price based on number of days and price per night
        const updatedRooms = initialRooms
            .map(room => ({
                ...room,
                totalPrice: room.price * numberOfDays,
                checkIn: dateRange[0].startDate,
                checkOut: dateRange[0].endDate,
                nights: numberOfDays
            }))
            .filter(room =>
                room.price >= priceRange[0] && room.price <= priceRange[1] &&
                room.maxGuests >= guests
            );

        // Sort rooms based on the selected sort order
        const sortedRooms = updatedRooms.sort((a, b) => {
            if (sortOrder === 'lowest') return a.totalPrice - b.totalPrice;
            if (sortOrder === 'highest') return b.totalPrice - a.totalPrice;
            return a.id - b.id;
        });

        setDisplayedRooms(sortedRooms);
    }, [dateRange, guests, priceRange, sortOrder]);

    useEffect(() => {
        filterRooms();
    }, [filterRooms]);

    const handleDateRangeChange = (ranges) => {
        setDateRange([ranges.selection]);
    };

    const handleSortChange = (e) => {
        setSortOrder(e.target.value);
    };

    const handlePriceChange = (value) => {
        setPriceRange(value);
    };

    const handleGuestsChange = (e) => {
        setGuests(parseInt(e.target.value, 10));
    };

    const handleSearch = () => {
        filterRooms();
        setCurrentPage(1);
    };

    const paginatedRooms = displayedRooms.slice((currentPage - 1) * roomsPerPage, currentPage * roomsPerPage);

    const totalPages = Math.ceil(displayedRooms.length / roomsPerPage);

    // Component to render service icons based on the icon name string
    const ServiceIcon = ({ iconName }) => {
        const IconComponent = Icons[iconName];
        return IconComponent ? <IconComponent /> : null;
    };

    return (
        <div className="search-page-container">
            <Navbar />
            <img src={TopImage} alt="Top Section" className="top-banner-image" />
            <h1 className="booking-heading">Book Now</h1>
            <ProgressBar currentStep="search" />

            <div className="booking-container">
                <div className="filter-container">
                    <div className="filter-item">
                        <label>Check In/Out</label>
                        <input
                            type="text"
                            readOnly
                            onClick={() => setOpenCalendar(!openCalendar)}
                            value={`${format(dateRange[0].startDate, 'MM/dd/yyyy')} → ${format(dateRange[0].endDate, 'MM/dd/yyyy')}`}
                        />
                        {openCalendar && (
                            <DateRange
                                ranges={dateRange}
                                onChange={handleDateRangeChange}
                                editableDateInputs={true}
                                moveRangeOnFirstSelection={false}
                                minDate={new Date()}
                            />
                        )}
                    </div>
                    <div className="filter-item">
                        <label>Guests</label>
                        <input
                            type="number"
                            placeholder="Guests 1"
                            value={guests}
                            onChange={handleGuestsChange}
                        />
                    </div>
                    <div className="filter-item">
                        <label>Price</label>
                        <Slider
                            range
                            min={33.5}
                            max={134.5}
                            step={0.5}
                            value={priceRange}
                            onChange={handlePriceChange}
                            trackStyle={{ backgroundColor: '#D4A017' }}
                            handleStyle={[{ borderColor: '#D4A017', backgroundColor: '#D4A017' }, { borderColor: '#D4A017', backgroundColor: '#D4A017' }]}
                            railStyle={{ backgroundColor: '#d9d9d9' }}
                            dotStyle={{ borderColor: '#D4A017' }}
                            activeDotStyle={{ borderColor: '#D4A017' }}
                        />
                        <div className="price-range-display">
                            <span>${priceRange[0]}</span>
                            <span>${priceRange[1]}</span>
                        </div>
                    </div>
                    <button className="search-button" onClick={handleSearch}>Search</button>
                </div>

                <div className="room-list-container">
                    <div className="sort-container">
                        <label>Sort by:</label>
                        <select value={sortOrder} onChange={handleSortChange}>
                            <option value="default">Default</option>
                            <option value="lowest">Lowest Price</option>
                            <option value="highest">Highest Price</option>
                        </select>
                    </div>

                    {paginatedRooms.map(room => (
                        <div className="room-card-container" key={room.id}>
                            <img src={room.image} alt={room.name} className="room-image" />
                            <div className="room-details">
                                <h3 className="room-name">{room.name}</h3>
                                <p className="room-price">${room.price} PER NIGHT</p>
                                <p className="room-total-price">For ${room.totalPrice ? room.totalPrice.toFixed(2) : room.price.toFixed(2)}</p>
                                <div className="room-icons-container">
                                    {room.services.map((service, index) => (
                                        <div className="icon-with-tooltip" key={index}>
                                            <ServiceIcon iconName={service.icon} />
                                            <span className="tooltip-text">{service.text}</span>
                                        </div>
                                    ))}
                                </div>
                                <Link
                                    to={`/booking/booking`}
                                    state={{
                                        room: {
                                            id: room.id,
                                            name: room.name,
                                            price: room.price,
                                            totalPrice: room.totalPrice,
                                            image: room.image,
                                            checkIn: room.checkIn,
                                            checkOut: room.checkOut,
                                            nights: room.nights,
                                            services: room.services.map(service => ({ icon: service.icon, text: service.text })),
                                        },
                                        guests: guests // Pass guests to Booking.js here
                                    }}
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <button className="room-button">Book Now</button>
                                </Link>
                            </div>
                        </div>
                    ))}

                    <div className="pagination-container">
                        <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>Previous</button>
                        {[...Array(totalPages)].map((_, index) => (
                            <button key={index} onClick={() => setCurrentPage(index + 1)} className={currentPage === index + 1 ? 'active-page' : ''}>
                                {index + 1}
                            </button>
                        ))}
                        <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Search;
